import { defineComponent as _defineComponent } from 'vue'
import { THGTag } from '@/interfaces/thg/THGTag';

    interface Props {
        tag: THGTag;
        closable?: boolean;
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'THGTagChip',
  props: {
    tag: null,
    closable: { type: Boolean, default: false }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
        (e: 'close', ev: Event): void;
    }), expose: any, slots: any, attrs: any }) {

const props = __props as { tag: THGTag, closable: boolean };

    

    

    const generateBGColor = (tag: THGTag) => {
        const red = tag.color_rgb?.red;
        const green = tag.color_rgb?.green;
        const blue = tag.color_rgb?.blue;

        return `background-color: rgb(${red}, ${green}, ${blue})`;
    };

return { __sfc: true,props, emit, generateBGColor }
}

})